import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

export const drillAuthTypes = {
    NoAuthentication: 'No Authentication',
    Plain: 'Plain'
};

@Metamodel.model({
    name: 'Drill',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Drill_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Drill_DisplayText)
    ]
})
export class DrillLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    public isLegacyConnector: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
